// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","logo":"Header_logo__UsziS","slogan":"Header_slogan__EXFhl"};